// ✅ CLEAN VERSION of cart-drawer.js
import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

(function () {
  const cartItemsElement =
    document.querySelector('cart-items') ||
    document.querySelector('cart-items-component');
  const atcItemFeatureIsEnabled =
    cartItemsElement?.dataset.enableConditionalAtcItem === 'true';

  if (atcItemFeatureIsEnabled && typeof window.userRemovedAutoAtcItem === 'undefined') {
    const stored = localStorage.getItem('userRemovedAutoAtcItemData');
    if (stored) {
      try {
        const parsed = JSON.parse(stored);
        const now = Date.now();
        if (parsed.value === true && parsed.expiresAt && now < parsed.expiresAt) {
          window.userRemovedAutoAtcItem = true;
        } else {
          window.userRemovedAutoAtcItem = false;
          localStorage.removeItem('userRemovedAutoAtcItemData');
        }
      } catch (err) {
        window.userRemovedAutoAtcItem = false;
        localStorage.removeItem('userRemovedAutoAtcItemData');
      }
    } else {
      window.userRemovedAutoAtcItem = false;
    }
  }
})();

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

  open() {
    this.showDialog();

    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}

/**
 * Defines a custom <cart-remove-button> element to track if the user removed the auto-added gift
 */
class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    const cartItemsElem = this.closest('cart-items') || this.closest('cart-items-component');
    if (
      cartItemsElem &&
      cartItemsElem.dataset.enableConditionalAtcItem === 'true' &&
      this.isAtcItemVariant(cartItemsElem, this.dataset.variantId)
    ) {
      window.userRemovedAutoAtcItem = true;
      const oneDayMs = 24 * 60 * 60 * 1000;
      const expiresAt = Date.now() + oneDayMs;
      const dataToStore = { value: true, expiresAt };
      localStorage.setItem('userRemovedAutoAtcItemData', JSON.stringify(dataToStore));
    }
  }

  isAtcItemVariant(cartItemsElem, variantId) {
    const atcItemVariantsCsv = cartItemsElem.dataset.atcItemVariantToAdd || '';
    const atcItemVariantsArray = atcItemVariantsCsv.split(',').map(s => s.trim()).filter(Boolean);
    return atcItemVariantsArray.includes(String(variantId));
  }
}

if (!customElements.get('cart-remove-button')) {
  customElements.define('cart-remove-button', CartRemoveButton);
}

// ❌ NOTE: The CartItemsComponent definition has been removed from here.
// ✅ The correct CartItemsComponent should be defined in component-cart-items.js ONLY